import { render } from "./ModalConfirmImage.vue?vue&type=template&id=b52a6b74&scoped=true"
import script from "./ModalConfirmImage.vue?vue&type=script&lang=js"
export * from "./ModalConfirmImage.vue?vue&type=script&lang=js"

import "./ModalConfirmImage.vue?vue&type=style&index=0&id=b52a6b74&scoped=true&lang=css"
import "./ModalConfirmImage.vue?vue&type=style&index=1&id=b52a6b74&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52a6b74"]])

export default __exports__